module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--27.09e71e9d.png";